<template>
    <v-content>
      <!-- Main area -->
      

       <!-- Side Menu -->       
       <app-top-toolbar v-if="showMenu" class="app--toolbar"></app-top-toolbar>
       <app-drawer class="app--drawer"></app-drawer>


        <!-- Page Header -->
        <app-page-header></app-page-header>
        <background></background>
        <div class="dd-viewport ">
        <transition
           name="bounce"
           enter-active-class="fadeInLeft"
           leave-active-class="fadeOutRight"
           mode="out-in"
           >
           <router-view class="animated" style="z-index:2;" ></router-view>
            
        </transition>
        </div>
      
      <!-- <v-footer
        dark
        height="auto"
        fixed
        inset        
      >
        <v-card
          class="flex"
          flat
          tile
        >
          

          <v-card-actions class="grey lighten-4 justify-center primary--text">
            &copy;2018 — <strong>DeepDigital B.V.</strong>
          </v-card-actions>
        </v-card>
      </v-footer> -->
      
       <notification ></notification> 
   </v-content>
</template>

<script>
// import { mapGetters } from 'vuex'
import {CKEY} from '../../config'
import Background from './Background'

import * as types from "../../store/types"
import { mapGetters } from 'vuex'
import Notification from "./Notification"
import FsLoader from "./FsLoader"

import AppDrawer from './AppDrawer'
import AppTopToolbar from './AppTopToolbar'
import AppPageHeader from './AppPageHeader'
import { registerChannel, registerEvent } from '../../plugins/core/dd.pusher'

import ColorMixin from '../../plugins/mixins/ColorMixin.js'
import { map } from 'leaflet';

export default {

  components:{
    Background,
    Notification,
    AppTopToolbar,
    AppDrawer,
    AppPageHeader,
    FsLoader,
    ColorMixin
  },
  data() {
    return {
      showMenu:true
    }
  },
  computed:{
    ...mapGetters({
      globalNotifications: types.GLOBAL_NOTIFICATIONS,      
      notify: types.SHOW_NOTIFICATION,
      currentUser: types.CURRENT_USER,
      userFavoriteAssets: types.USER_FAVORITE_ASSETS,
    })
  },
  mixins:[ColorMixin],
  methods:{
    loadDefaultData(){      
      this.$store.dispatch(types.USER_FAVORITE_ASSETS,{data:{"userId":this.currentUser.id },params:{per_page:200, include:"asset"}})
    },
    startGeneralChannels(){
        console.log("Subscribe pusher channel")

        this.$pusher.channels['presence-user-channel'].bind('pusher:member_added', (data) => {      
          //    this.$toasted.show(`${data.info.name} is online`, {
          //    position: 'bottom-right',
          //    duration: 3000,
          //    className: 'success-notification'
          //  })
        })
        this.$pusher.channels['presence-user-channel'].bind('pusher:member_removed', (data) => {      
          // this.$toasted.show(`${data.info.name} is offline gegaan`, {
          //   position: 'bottom-right',
          //   duration: 3000,        
          // })
        })   
    },
    startApplicationNotificationChannel(){        
        let channel = 'private-application-notification-channel-'+this.currentUser.tenant.id    
        let vm = this

        console.log("start subscription on channel: "+channel)
        registerChannel(channel)                                                                                  //   App\\Events\\SendApplicationNotification
        registerEvent(channel, 'App\\Events\\SendApplicationNotification', (data) => {
          vm.handleApplicationNotification(data.data)
        })            
    },
    startUserNotificationChannel(){
        let channel = 'private-user-notification-channel-'+this.currentUser.id
        let vm = this

        console.log("start subscription on channel: "+channel)
        registerChannel(channel)
        registerEvent(channel, 'App\\Events\\SendUserNotification', (data) => {
          vm.handleNotification(data.message)
        } )
    },
    handleNotification(message){
      
       this.showNotification(message);   
       this.$store.dispatch(types.ADD_GLOBAL_NOTIFICATIONS, message); 
       if(message.type == 'user_message'){
          this.$store.dispatch(types.USER_MESSAGES, {
            data:{
                userId: message.options.from_user_id
            },
            params: {
                include: '',
                per_page: 200
            }
        })    
       }      
    },
    handleApplicationNotification(data){  
        if(data.action == 'update_current_user'){
            this.$store.dispatch(types.LOAD_CURRENT_USER).then(() => {
                // if type is a role update menu should be refreshed after current_user is refreshed
                if(data.type == "role_update"){
                    this.reloadMenu();
                }
            })
        }
    },
    showNotification(data){       
        this.$toasted.show(this.createBlock(data), {
            position: 'bottom-right',
            duration: 6000,    
            keepOnHover: true,
            // icon:this.setIcon(data.type),
            theme: "toast-type-"+data.type
        })
    },   
    setIcon(type){
        if(type == "notification")
          return "fa-bell"

        if(type == "system")
          return "fa-desktop"

        if(type == "user_message")
          return "fa-user"

        return "alert-circle"          
    },
    reloadMenu(){
        this.showMenu=false
        this.$nextTick(() => {
          this.showMenu=true
        })
    },
    createBlock(item){
      return `<div class="notification">
        <div class="notification-avatar"><img src="${item.from_avatar}"></div>
        <div class="notification-message">
        <div class="notification-title">
          <strong>${item.subject}</strong>
        </div>
        <div class="notification-message">
          <span class='notification-from'>${item.from} </span> &mdash; ${item.message}
        </div>
        </div>
      </div>`      
      // return `<div class="toast-container">
      //           <div>
      //               <div class="toast-notification-timestamp">${data.timestamp}</div>                
      //               <div class="toast-notification-title">${data.from}</div>
      //               <div class="toast-notification-body">${data.message}</div>
      //           </div>
      //         </div>`;
    }
  },
  mounted(){
    this.loadDefaultData()
    this.startGeneralChannels()
    this.startUserNotificationChannel()
    this.startApplicationNotificationChannel()
  }
}
</script>

<style>

  .notification{
    display: flex;    
    background-color: #fff;
    border: 1px solid #ccc;
    font-family: 'Roboto', sans-serif;
    line-height: 1.5;
    width: 400px;
    -webkit-box-shadow: inset 0 0 1px #2c3e50;
    padding: 8px 8px;
  }
  .notification-avatar{
    padding: 10px 10px;
    width: 80px;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    flex: 1;
    
  }

  .notification-avatar img{
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }

  .notification-title{
    width: 100%;
    font-weight: 400;
    color: rgba(0,0,0,0.74);
    font-size: 14px;
      overflow: hidden;
    text-overflow: ellipsis;
  }

  .notification-from{
    width: 100%;
    font-weight: 500;
    color: #2C3E50;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .notification-message{
    width: 100%;
    font-weight: 400;
    color: rgba(0,0,0,0.54);
    font-size: 14px;
      overflow: hidden;
    text-overflow: ellipsis;

  }

  /* .toast-container{
    padding:8px;
    width:240px;
  }

  .toasted i{
    font-size:28px;
  }
 .toast-type-notification{
    background-color:#03a9f4;
    border: 1px solid;
    border-radius:10px;     
    color:white;
 } 
 .toast-type-system{
    background-color:#2C3E50;
    color:white;
    border: 1px solid;
    border-radius:10px;     
 }
 .toast-type-user_message{
    background-color: #FF5722;
    color:white;
    border: 1px solid;
    border-radius:10px;     
 }
 .toast-notification-timestamp{
   text-align:right;
 } 
 .toast-notification-title{
    font-style:italic;
    font-weight:bold;
 }  */
.dd-viewport{
  z-index: 2;
  position: relative;;
  /* height: calc(100% - 169px); */
  height: 100%;
}
</style>
